(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('CampagnaAmazon', CampagnaAmazon);

    CampagnaAmazon.$inject = ['$resource', 'DateUtils'];

    function CampagnaAmazon ($resource, DateUtils) {
        var resourceUrl =  'api/campagna-amazons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datains = DateUtils.convertDateTimeFromServer(data.datains);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
